<template>
    <div>
        <h4 class="font-weight-bold title mb-3">{{ title }}</h4>
        <v-chip-group
            column
        >
            <v-chip
                class="text-lowercase chip"
                color="grey lighten-3"
                v-for="attribute in attributes"
                :key="attribute.id"
                :to="attribute.link"
            >{{ attribute.lang_name }}</v-chip>
        </v-chip-group>
    </div>
</template>

<script>
    export default {
        name: 'HomeAttributes',
        props: {
            title: {
                required: true,
                type: String,
            },
            attributes: {
                required: true,
                type: Array,
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../sass/variables";

    .chip:hover {
        background-color: $mainYellow!important;
        border-color: $mainYellow!important;
        color: white!important;
    }
</style>